import React, { useState } from 'react';
import './settings.scss';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import PresetDTO from '../../../dto/PresetDTO';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { allRolePermissionKeys } from '../index';
import { createRole, saveRole } from '../actions';
import notificationDecorator, {
  errorNotification,
  successNotification,
} from '../../Notifications/notificationDecorator';
import { getResponseError } from '../../../utils/utils';

window.prevSettings = false;

export default function RoleForm(props) {
  const { role = {}, loadData = () => {} } = props;
  const { permissions = {}, name, id } = role;
  const DTO = new PresetDTO();
  const attributes = DTO.getAttributesByName();
  const [isOpen, setOpen] = useState(false);
  const [isAll, setAll] = useState(false);
  const [isSome, setSome] = useState(false);
  const [isSettingsAll, setSettingsAll] = useState(false);
  const [isSettingsSome, setSettingsSome] = useState(false);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;

  const settingKeys = [
    'settings_camera',
    'settings_complex',
    'settings_presets',
    'settings_export',
    'settings_user',
    'settings_wanted',
    'settings_violation',
    'settings_calibration',
  ];

  const {
    register,
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
  } = useForm({
    mode: 'onBlur',
    defaultValues: permissions,
    resetOptions: {
      keepDirtyValues: true, // user-interacted input will be retained
      keepErrors: true, // input errors will be retained with value update
    },
  });
  const handleSaveRole = () => {
    dispatch(saveRole({
      id,
      data: {
        name,
        permissions: getValues(),
      },
    })).then(() => {
      loadData();
      successNotification(formatMessage({ id: 'role.save' }), formatMessage({ id: 'role.save.success' }));
    }).catch(response => errorNotification(formatMessage({ id: 'role.save' }), getResponseError(response)));
  };

  const calculateState = values => {
    const all = allRolePermissionKeys.every(p => values[p]);
    const some = allRolePermissionKeys.some(p => values[p]) && !all;
    const isSettingsAll = settingKeys.every(p => values[p]);
    const isSettingsSome = settingKeys.some(p => values[p]) && !isSettingsAll;
    setAll(all);
    setSome(some);
    setSettingsAll(isSettingsAll);
    setSettingsSome(isSettingsSome);
    if (window.prevSettings !== values.settings) {
      window.prevSettings = values.settings;
      settingKeys.map(name => setValue(name, values.settings));
    }
  };

  React.useEffect(() => {
    const subscription = watch(calculateState);
    return () => subscription.unsubscribe();
  }, [watch]);

  React.useEffect(() => {
    calculateState(permissions);
  }, []);

  const renderCheckBox = (name, index) => (
    <FieldDTO
      key={index}
      type="text"
      control={control}
      component={CheckBoxInputWithLabel}
      withLabel
      addPlaceholder
      dtoObject={{
        labelKey: `menu.${name}`,
        name,
      }}
      variant="material"
    />
  );

  return (
    <>
      <div className="settings-header">
        <div className="settings-label">{formatMessage({ id: 'role.permission' })}</div>
        <div className="settings-buttons">
          <Button className="save-button" onClick={handleSaveRole}>{formatMessage({ id: 'app.save' })}</Button>
        </div>
      </div>
      <div className="settings-form role-wrapper">
        <div className="settings-view-form user-form">

          <div className="role-form custom-scroll-theme">
            <CheckBoxInputWithLabel
              label={formatMessage({ id: 'role.full.access' })}
              withLabel
              addPlaceholder
              variant="material"
              inputClassName={classNames('cbl-group-checkbox', { 'some-child': isSome }, { 'every-child': isAll })}
              inputProps={{
                value: isAll,
                onChange: () => {
                  if (isAll) {
                    allRolePermissionKeys.map(name => setValue(name, false));
                  } else {
                    allRolePermissionKeys.map(name => setValue(name, true));
                  }
                },
              }}
            />
            {renderCheckBox('dashboard')}
            {renderCheckBox('session')}
            {renderCheckBox('detection')}
            {renderCheckBox('zones')}
            {renderCheckBox('system_events')}
            {renderCheckBox('metrology')}
            <div className={classNames('check-box-accordion', { open: isOpen })}>
              <div
                className="cbl-accordion-label"
                onClick={() => {
                  setOpen(!isOpen);
                }}
              >
                <div className="cbl-checkbox bordered-checkbox">
                  <FieldDTO
                    type="text"
                    control={control}
                    component={CheckBoxInputWithLabel}
                    withLabel
                    addPlaceholder
                    dtoObject={{
                      labelKey: 'menu.settings',
                      name: 'settings',
                    }}
                    variant="material"
                  />
                </div>
                <div className="accordion-icons accordion-icons-arrow">
                  <Icons customIcon className="check-box-accordion-icon" width={12} height={8} icon="arrow-down" />
                </div>
              </div>
              <div className="check-box-accordion-content">
                {settingKeys.map(renderCheckBox)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
